import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { AuthPageShell } from "@/components/layout/auth-page-shell";
import { toast } from "sonner";
import { customInstance } from "@/lib/axios";

export function ForgotPasswordPage() {
  const [email, setEmail] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) {
      toast.error("Enter your email address.");
      return;
    }
    setIsLoading(true);
    try {
      await customInstance.post("/api/auth/password-reset/", { email: trimmed });
      setSubmitted(true);
      toast.success("Request received.");
    } catch {
      setSubmitted(true);
      toast.success("Request received.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <AuthPageShell>
      <Card className="w-full max-w-md">
        <CardHeader className="space-y-1">
          <div className="flex justify-center mb-4">
            <img src="/logo-full.png" alt="DealerDog" className="h-20 sm:h-24 w-auto" />
          </div>
          <CardTitle className="text-2xl font-bold text-center">Forgot password</CardTitle>
          <CardDescription className="text-center">
            Enter the email you use to sign in. If an account exists for that email, you will receive password reset
            instructions shortly.
          </CardDescription>
          <p className="text-center text-sm pt-2">
            <Link to="/login" className="text-primary hover:underline">
              Back to login
            </Link>
          </p>
        </CardHeader>
        <CardContent>
          {submitted ? (
            <p className="text-sm text-gray-700 text-center">
              If an account exists for that email, you will receive password reset instructions shortly. Check your inbox
              and spam folder.
            </p>
          ) : (
            <form onSubmit={handleSubmit} className="space-y-4">
              <div className="space-y-2">
                <Label htmlFor="email">Email</Label>
                <Input
                  id="email"
                  type="email"
                  autoComplete="email"
                  placeholder="you@company.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <Button type="submit" className="w-full" disabled={isLoading}>
                {isLoading ? "Sending…" : "Send reset link"}
              </Button>
            </form>
          )}
        </CardContent>
      </Card>
    </AuthPageShell>
  );
}
